import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Hit = ({ className }) => {
  return (
    <svg
      viewBox='0 0 301 368'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-hit', { [className]: className })}
    >
      <path
        d='M196.269 215.457V129.817C196.269 104.952 176.107 84.79 151.242 84.79C126.377 84.79 106.215 104.952 106.215 129.817V241.945L75.843 211.573L75.7823 211.619C58.1234 195.067 30.4214 195.371 13.1873 212.605C-4.39576 230.188 -4.39576 258.709 13.1873 276.292L104.895 368H300.736V215.442H196.254L196.269 215.457ZM278.844 346.124H113.967L28.6616 260.818C19.6349 251.791 19.6349 237.121 28.6616 228.094C37.6883 219.067 52.3585 219.067 61.3852 228.094L106.185 272.894H128.076V129.817C128.076 117.058 138.453 106.682 151.212 106.682C163.971 106.682 174.348 117.058 174.348 129.817V237.348H278.814V346.124H278.844ZM239.082 129.817H217.19C217.19 93.4526 187.592 63.8542 151.227 63.8542C114.863 63.8542 85.2641 93.4374 85.2641 129.817H63.3725C63.3725 81.3766 102.786 41.9627 151.227 41.9627C199.668 41.9627 239.082 81.3766 239.082 129.817ZM281.059 129.817H259.168C259.168 70.3018 210.742 21.8916 151.242 21.8916C91.7421 21.8916 43.3015 70.3018 43.3015 129.817H21.4099C21.4099 58.241 79.6509 0 151.227 0C222.803 0 281.044 58.241 281.044 129.817H281.059Z'
        fill='currentColor'
      />
    </svg>
  );
};

Hit.propTypes = {
  className: PropTypes.string,
};

export default Hit;
